//@ts-nocheck

import React, { useEffect, useState } from "react";
import CustomTextField from "../../../commonComponents/TextFieldComponent";
import CustomSelectField from "../../../commonComponents/CommonSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchBusinesscategory,
  setSubCategory,
} from "../../../../redux/slice/businessSlice";
import { einNumber, formatPhone, ssNumber, formatZipCode } from "../../../../utils/formatUtils";
import { setBenificial, setBenificialPercentage } from "../../../../redux/slice/userSlice";
import { Box, IconButton, Popover, Typography } from "@mui/material";
import CommonDatePicker from "../../../commonComponents/CommonDatePicker";
import dayjs from "dayjs";
import moment from "moment";
import Info from "../../../../assets/info.png";

interface BusinessFormProps {
  values: any;
  formik: any;
  errors: any;
  touched: any;
  size?: string;
  ispurchaseprofile?: boolean;
  isDisabled?: boolean;
  setErrors: any;
  handlePaste: (e: React.ClipboardEvent<HTMLInputElement>) => void;
}


function BusinessForm({
  values,
  formik,
  errors,
  touched,
  size,
  ispurchaseprofile,
  isDisabled,
  setErrors,
  handlePaste

}: BusinessFormProps) {
  const dispatch = useDispatch();
  const { loginInvestorId } = useSelector((state: any) => state.user);
  const { states } = useSelector((state: any) => state.stateCounty);
  const { businessType, businesscategory, subCategory } = useSelector(
    (state: any) => state.business
  );
  const [useId, setId] = useState<number>();
  const [state, setState] = useState({
    dbaPopoverOpen: false,
    registrationPopoverOpen: false,
    dbaAnchorEl: null,
    registrationAnchorEl: null,
  });

  const { dbaPopoverOpen, registrationPopoverOpen, dbaAnchorEl, registrationAnchorEl } = state;
  useEffect(() => {
    dispatch(fetchBusinesscategory());
  }, []);

  const stateOptions =
    states?.map((state: any) => ({
      value: state.value || state,
      label: state.label || state,
    })) || [];
  // Transform business types into the correct format
  const types =
    businessType?.map((ele: any) => ({
      value: ele.id?.toString(),
      label: ele.businessType,
      data: ele,
    })) || [];

  // Transform categories into the correct format
  const categoryOptions =
    businesscategory?.map((category: any) => ({
      label: category.categoryName,
      value: category.id?.toString(),
      id: category,
    })) || [];

  useEffect(() => {
    if (loginInvestorId && values?.BusinessCategoriesId) {
      const businessCat = businesscategory?.filter((category: any) =>
        Number(category.id) === Number(values.BusinessCategoriesId),
      );

      const tempdata = businessCat[0]?.children.map((categoryId: any) => ({
        label: categoryId.categoryName,
        value: categoryId.id?.toString(),
      }));
      dispatch(setSubCategory(tempdata));
    }
  }, []);

  useEffect(() => {
    if (useId !== undefined) {
      dispatch(setBenificial(useId));
    }
  }, [useId]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    const maxLengths = { IdNumber: 9, ZipCode: 9, Phone: 10 };
    let trimmedValue = value;
    let cursorPosition = event.target.selectionStart;
    const prevValue = formik.values[name] || "";

    formik.setFieldTouched(name, true, false);
    setErrors && setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[name];
      return newErrors;
    });

    if (name === "Phone" || name === "phone") {
      const originalValue = value;
      const digitsOnly = value.replace(/\D/g, "");
      if (digitsOnly.length > maxLengths.Phone) {
        return; // Freeze value
      }
      // Calculate new cursor position based on digits before cursor
      const digitsBeforeCursor = originalValue.slice(0, cursorPosition).replace(/\D/g, "").length;
      // Calculate formatting characters before the cursor position
      const formattingBeforeCursor = originalValue.slice(0, cursorPosition).replace(/[0-9]/g, '').length;
      // The new cursor position should be: digits position + formatting characters
      let newCursorPosition = digitsBeforeCursor + formattingBeforeCursor;
      // Remove all non-digit characters
      let trimmedValue = value.replace(/[A-Za-z]/g, "").replace(/[\s(),-]/g, "");
      // Format the phone number with proper formatting
      let formattedValue = trimmedValue;
      if (trimmedValue.length >= 3) {
        formattedValue = `(${trimmedValue.slice(0, 3)})`;
        if (trimmedValue.length >= 6) {
          formattedValue += ` ${trimmedValue.slice(3, 6)}`;
          if (trimmedValue.length >= 10) {
            formattedValue += `-${trimmedValue.slice(6, 10)}`;
          } else {
            formattedValue += trimmedValue.slice(6);
          }
        } else {
          formattedValue += ` ${trimmedValue.slice(3)}`;
        }
      }
      formik.setFieldValue(name, trimmedValue, false); // Store only digits
      setTimeout(() => {
        const input = document.querySelector(`input[name='${name}']`);
        if (input && input === document.activeElement) {
          let actualPosition = digitsBeforeCursor;
          if (digitsBeforeCursor > 0) actualPosition += 1; // Opening parenthesis
          if (digitsBeforeCursor > 3) actualPosition += 2; // Closing parenthesis + space
          if (digitsBeforeCursor > 6) actualPosition += 1; // Hyphen
          input.setSelectionRange(actualPosition, actualPosition);
        }
      }, 0);
      formik.setFieldTouched(name, true, false);
      return;
    } else if (name === "IdNumber") {
      const numbersOnly = value.replace(/\D/g, "");
      // If already at max length and trying to add more, block input
      if (
        numbersOnly.length > maxLengths.IdNumber ||
        (prevValue.length === maxLengths.IdNumber && numbersOnly.length > prevValue.length)
      ) {
        return; // Prevent further input
      }
      const formatted = einNumber(numbersOnly);
      setTimeout(() => {
        const input = document.querySelector(`input[name='${name}']`);
        if (input) {
          // Special case: if the previous value was longer and the new value is shorter by 1, and the cursor is at position 0, set cursor to 0
          if (
            prevValue &&
            prevValue.length > value.length &&
            cursorPosition === 0
          ) {
            input.setSelectionRange(0, 0);
          } else {
            // Count digits before the cursor in the formatted value
            let digitsBeforeCursor = 0;
            for (let i = 0; i < cursorPosition; i++) {
              if (value[i] && /\d/.test(value[i])) digitsBeforeCursor++;
            }
            // Find the position in the formatted value after the same number of digits
            let digitCount = 0;
            let newCursorPos = 0;
            for (; newCursorPos < formatted.length; newCursorPos++) {
              if (/\d/.test(formatted[newCursorPos])) digitCount++;
              if (digitCount === digitsBeforeCursor) {
                newCursorPos++;
                break;
              }
            }
            // If deleting at the end, keep at end
            if (cursorPosition === value.length) {
              input.setSelectionRange(formatted.length, formatted.length);
            } else {
              input.setSelectionRange(newCursorPos, newCursorPos);
            }
          }
        }
      }, 0);
      formik.setFieldValue(name, formatted, false); // Store formatted value!
      formik.setFieldTouched(name, true, false);
      return;
    } else if (name === "ZipCode") {
      const numbersOnly = value.replace(/\D/g, "");
      // If already at max length and trying to add more, block input
      if (
        numbersOnly.length > maxLengths.ZipCode ||
        (prevValue.length === maxLengths.ZipCode && numbersOnly.length > prevValue.length)
      ) {
        return; // Prevent further input
      }
      const formatted = formatZipCode(numbersOnly);
      setTimeout(() => {
        const input = document.querySelector(`input[name='${name}']`);
        if (input) {
          // Special case: if the previous value was longer and the new value is shorter by 1, and the cursor is at position 0, set cursor to 0
          if (
            prevValue &&
            prevValue.length > value.length &&
            cursorPosition === 0
          ) {
            input.setSelectionRange(0, 0);
          } else {
            // Count digits before the cursor in the raw (unformatted) value
            let digitsBeforeCursor = 0;
            for (let i = 0; i < cursorPosition; i++) {
              if (value[i] && /\d/.test(value[i])) digitsBeforeCursor++;
            }
            // Find the position in the formatted value after the same number of digits
            let digitCount = 0;
            let newCursorPos = 0;
            for (; newCursorPos < formatted.length; newCursorPos++) {
              if (/\d/.test(formatted[newCursorPos])) digitCount++;
              if (digitCount === digitsBeforeCursor) {
                newCursorPos++;
                break;
              }
            }
            // If deleting at the end, keep at end
            if (cursorPosition === value.length) {
              input.setSelectionRange(formatted.length, formatted.length);
            } else {
              input.setSelectionRange(newCursorPos, newCursorPos);
            }
          }
        }
      }, 0);
      formik.setFieldValue(name, formatted, false); // Store formatted value
      formik.setFieldTouched(name, true, false);
      const isValid = /^\d{5}(-\d{4})?$/.test(formatted);
      if (!isValid && numbersOnly.length >= 5) {
        formik.setErrors({
          ...formik.errors,
          [name]: "ZIP code must be in format 00000 or 00000-0000",
        });
      } else {
        const newErrors = { ...formik.errors };
        delete newErrors[name];
        formik.setErrors(newErrors);
      }
      return;
    } else if (maxLengths[name]) {
      trimmedValue = value.slice(0, maxLengths[name]);
    } else if (name === "City") {
      // Remove invalid characters (allow letters, spaces)
      trimmedValue = value.replace(/[^a-zA-Z\s'-]/g, "");
    }
    formik.setFieldValue(name, trimmedValue, false);
    formik.setFieldTouched(name, true, false);
  };

  const handleselectChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    _data: any,
    details: any,
    elements: any
  ) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name === "BusinessCategoriesId" && details?.children) {
      const tempdata = details?.children?.map((categoryId: any) => ({
        label: categoryId.categoryName,
        value: categoryId.id?.toString(),
      }));
      dispatch(setSubCategory(tempdata));
    }

    if (name === "BusinessTypeId" && elements?.data) {
      const isBeneficialRequired = Number(elements.data.isBeneficielRequired);
      dispatch(setBenificial(isBeneficialRequired));
      dispatch(setBenificialPercentage(elements.data.minimumPercentage))
      setId(isBeneficialRequired);
    }

    formik.setFieldValue(name, value);
  };

  const handleDateChange = (date: any) => {
    formik.setFieldValue(
      "RegistrationDate",
      date ? dayjs(moment(date.$d).format("YYYY-MM-DD")) : null
    );
    formik.setFieldTouched("RegistrationDate", true, false);
  };

  const handleOpen = (event: any, type: string) => {
    setState(prev => ({
      ...prev,
      [`${type}PopoverOpen`]: true,
      [`${type}AnchorEl`]: event.currentTarget,
    }));
  };

  const handleClose = (type: string) => {
    setState(prev => ({
      ...prev,
      [`${type}PopoverOpen`]: false,
      [`${type}AnchorEl`]: null,
    }));
  };
  return (
    <>
      {ispurchaseprofile && (
        <div className="grid md:grid-cols-2 gap-3 md:gap-4 mb-4">
          <CustomTextField
            label="Profile Name"
            name="profileName"
            value={values.profileName}
            onChange={handleInputChange}
            error={touched.profileName && !!errors.profileName}
            helperText={touched.profileName && errors.profileName}
            size={size}
          />
        </div>
      )}
      <Typography
        variant="h6"
        fontSize={16}
        fontWeight={400}
        mb={1}
        data-testid="personal-info-title"
      >
        Enter Business Information
      </Typography>
      <Box
        // height={{ md: "15rem", sm: "100%" }}
        pr={1}
        py={1}
      >
        <div className="grid md:grid-cols-2 gap-3 md:gap-4 mb-4">
          <CustomTextField
            label="Legal Business Name"
            name="BusinessName"
            value={values.BusinessName}
            onChange={handleInputChange}
            onPaste={handlePaste}
            error={touched.BusinessName && !!errors.BusinessName}
            helperText={touched.BusinessName && errors.BusinessName}
            size={size}
          />
          <CustomSelectField
            label="Business Type"
            name="BusinessTypeId"
            options={types}
            value={values.BusinessTypeId}
            onChange={handleselectChange}
            error={touched.BusinessTypeId && !!errors.BusinessTypeId}
            helperText={touched.BusinessTypeId && errors.BusinessTypeId}
            dataTestid={"select-test"}
            size={size}
          />
          <div className="flex">
            <CustomTextField
              label={
                <Box display={"flex"}>
                  Doing-business as
                </Box>
              }
              name="OperatingAs"
              value={values.OperatingAs || ""}
              sx={{ width: "91%" }}
              onChange={handleInputChange}
              onPaste={handlePaste}
              size={size}
              error={touched.OperatingAs && !!errors.OperatingAs}
              helperText={touched.OperatingAs && errors.OperatingAs}

            />
            <img
              src={Info}
              alt="info"
              onClick={(e) => handleOpen(e, "dba")}
              style={{ height: "16px", width: "16px", margin: "auto" }}
            />
            <Popover
              open={dbaPopoverOpen}
              anchorEl={dbaAnchorEl}
              onClose={() => handleClose("dba")}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                marginTop: "10px",
              }}
              slotProps={{
                paper: {
                  sx: {
                    overflow: "visible",
                    borderRadius: "8px",
                    borderTopLeftRadius: 3,
                    paddingX: 2,
                    paddingY: 1,
                    maxWidth: 300,
                    ml: 10,
                    mt: 1,
                    boxShadow: "3px 3px 5px 2px rgba(0,0,0,0.1)",
                    "&:after,&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 8,
                      left: -8,
                      width: 18,
                      height: 18,
                      backgroundColor: "white",
                      transform: "rotate(45deg)",
                      boxShadow: "-3px 3px 5px -2px rgba(0,0,0,0.1)",
                    },
                  },
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="body2"
                  fontWeight={"400"}
                  fontSize={14}
                  sx={{
                    color: "#3B3B3B",
                    // marginTop: 1,
                  }}
                >
                  This is the name under which your business operates. If it is the same as your Legal Business Name, enter the same name here.
                </Typography>
              </Box>
            </Popover>
          </div>

          <CustomTextField
            label="Business EIN"
            name="IdNumber"
            value={einNumber(values.IdNumber) || ""}
            onChange={handleInputChange}
            onPaste={handlePaste}
            error={touched.IdNumber && !!errors.IdNumber}
            helperText={touched.IdNumber && errors.IdNumber}
            size={size}
          />

          <CustomSelectField
            label="Category"
            name="BusinessCategoriesId"
            options={categoryOptions}
            value={values.BusinessCategoriesId}
            onChange={handleselectChange}
            error={
              touched.BusinessCategoriesId && !!errors.BusinessCategoriesId
            }
            helperText={
              touched.BusinessCategoriesId && errors.BusinessCategoriesId
            }
            size={size}
          />
          <CustomSelectField
            label="Sub-Category"
            name="subCategory"
            options={subCategory}
            disabled={!(values.BusinessCategoriesId)}
            value={values.subCategory}
            onChange={handleselectChange}
            error={touched.subCategory && !!errors.subCategory}
            helperText={touched.subCategory && errors.subCategory}
            size={size}
          />
        </div>
        <div className="grid md:grid-cols-2 my-3 gap-3 md:gap-4">
          <div className="flex">
            <CommonDatePicker
              label="Registration Date"
              name="RegistrationDate"
              sx={{ width: "91%" }}
              disableFuture={true}
              value={values.RegistrationDate || null}
              onChange={handleDateChange}
              touched={touched.RegistrationDate}
              error={touched.RegistrationDate && !!errors.RegistrationDate}
              helperText={touched.RegistrationDate && errors.RegistrationDate}
              size={size}
              data-testid="date-of-birth-picker"
            />
            <img
              src={Info}
              alt="info"
              onClick={(e) => handleOpen(e, "registration")}
              style={{ height: "16px", width: "16px", margin: "auto" }}
            />
            <Popover
              open={registrationPopoverOpen}
              anchorEl={registrationAnchorEl}
              onClose={() => handleClose("registration")}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                marginTop: "10px",
              }}
              slotProps={{
                paper: {
                  sx: {
                    overflow: "visible",
                    borderRadius: "8px",
                    borderTopLeftRadius: 3,
                    paddingX: 2,
                    paddingY: 1,
                    maxWidth: 300,
                    ml: 10,
                    mt: 1,
                    boxShadow: "3px 3px 5px 2px rgba(0,0,0,0.1)",
                    "&:after,&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 8,
                      left: -9,
                      width: 18,
                      height: 18,
                      backgroundColor: "white",
                      transform: "rotate(45deg)",
                      boxShadow: "-3px 3px 5px -2px rgba(0,0,0,0.1)",
                    },
                  },
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="body2"
                  fontWeight={"400"}
                  fontSize={14}
                  sx={{
                    color: "#3B3B3B",
                    // marginTop: 1,
                  }}
                >
                  This is the date when the business was incorporated with the state
                </Typography>
              </Box>
            </Popover>
          </div>
          <CustomSelectField
            label="Registration State"
            name="RegistrationState"
            options={stateOptions}
            value={values.RegistrationState || ""}
            onChange={handleselectChange}
            error={touched.RegistrationState && !!errors.RegistrationState}
            helperText={touched.RegistrationState && errors.RegistrationState}
            size={size}
          />
        </div>
        <div className="grid md:grid-cols-1 my-3 gap-3 md:gap-4">
          <CustomTextField
            label={
              <Box display={"flex"}>
                Business Website
                <Typography sx={{
                  fontSize: '0.7rem',
                  fontStyle: 'italic',
                  color: '#9FA4AB',
                  ml: 1,
                  alignSelf: 'flex-end',  // Aligns the text at the bottom
                  marginY: 'auto'       // Pushes it to the bottom of the container
                }}>(Optional)</Typography>
              </Box>
            }
            name="BusinessWebsite"
            value={values.BusinessWebsite || ""}
            onChange={handleInputChange}
            onPaste={handlePaste}
            error={touched.BusinessWebsite && !!errors.BusinessWebsite}
            helperText={touched.BusinessWebsite && errors.BusinessWebsite}
            size={size}
          />
        </div>
        <div className="grid md:grid-cols-2 my-3 gap-3 md:gap-4">
          <CustomTextField
            label="Business Email Address"
            name="Email"
            disabled={isDisabled}
            value={values.Email || ""}
            onChange={handleInputChange}
            onPaste={handlePaste}
            error={touched.Email && !!errors.Email}
            helperText={touched.Email && errors.Email}
            size={size}
          />
          <CustomTextField
            label="Business Phone Number"
            name="Phone"
            value={formatPhone(values.Phone) || ""}
            onChange={handleInputChange}
            onPaste={handlePaste}
            error={touched.Phone && !!errors.Phone}
            helperText={touched.Phone && errors.Phone}
            size={size}
          />
        </div>
        <div className="grid md:grid-cols-2 gap-3 md:gap-4">
          <CustomTextField
            label="Business Address"
            name="DeliveryLine"
            value={values.DeliveryLine || ""}
            onChange={handleInputChange}
            onPaste={handlePaste}
            error={touched.DeliveryLine && !!errors.DeliveryLine}
            helperText={touched.DeliveryLine && errors.DeliveryLine}
            size={size}
          />
          <CustomTextField
            label="City"
            name="City"
            value={values.City || ""}
            onChange={handleInputChange}
            onPaste={handlePaste}
            error={touched.City && !!errors.City}
            helperText={touched.City && errors.City}
            size={size}
          />
          <CustomSelectField
            label="State"
            name="State"
            options={stateOptions}
            value={values.State}
            onChange={handleselectChange}
            error={touched.State && !!errors.State}
            helperText={touched.State && errors.State}
            size={size}
          />
          <CustomTextField
            label="Zip Code"
            name="ZipCode"
            value={values.ZipCode || ""}
            onChange={handleInputChange}
            onPaste={handlePaste}
            error={touched.ZipCode && !!errors.ZipCode}
            helperText={touched.ZipCode && errors.ZipCode}
            size={size}
          />
        </div>
      </Box>
    </>
  );
}

export default BusinessForm;
